/*
 * Audience to Engine translation
 *
 * Maintains union type over the translation layer
 * so it can be discriminated further below the computation
 */
export var translate = function (audienceDefinition) {
    return {
        filter: {
            any: false,
            queries: audienceDefinition.definition,
        },
        rules: [
            {
                reducer: {
                    name: 'count',
                },
                matcher: {
                    name: 'gt',
                    args: audienceDefinition.occurrences,
                },
            },
        ],
    };
};
//# sourceMappingURL=translate.js.map